import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import ROLES from 'config/roles';
import { pushQueryParams } from 'services/history';
import ROUTES from 'config/routes';
import pageLayout from 'HOC/pageLayout';
import withQueryParams from 'HOC/withQueryParams';
import ForumModule from 'modules/forum';
import PagesModule from 'modules/pages';
import PageTitle from 'components/PageTitle';
import ForumCard from 'components/ForumCard';
import Pagination from 'components/Pagination';
import Preloader from 'components/Preloader';
import LeftSide from './LeftSide';
import TextPage from './TextPage';
import CallToAction from './CallToAction';


const Forum = props => {
  const { forum_categories, getCategories, list, total, items, getCatalog, isFetchingForum, queryParams, isAuth, role, dataPage, getForumCommonData, resetCatalog } = props;
  const seo = dataPage?.seo;
  const title = dataPage?.content?.title;

  const categoryId = queryParams.category_id === 'all' ? '' : parseInt(queryParams.category_id);
  const pageNumber = parseInt(queryParams.page) || 1;
  const author = queryParams.author || "";

  useEffect(() => {
    {
      getCatalog(pageNumber, items, categoryId, author);
    }
  }, [pageNumber, categoryId, author]);

  useEffect(() => {
    {
      getCategories();
    }
    getForumCommonData('forums');

    return () => resetCatalog();
  }, []);

  const handlePaginationChange = page => {
    pushQueryParams({ page });
  }

  return (
    <>
      {
        seo &&
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      }
      <div className="page-body">
        {
          isAuth
            ? <PageTitle title={title} align="center"
              linkTitle="About Forum"
              linkText={ROUTES.aboutForum} />
            : <PageTitle title={title} align="center" />
        }

        <div className="content-container">
          <div className="container">
            {
              (role === ROLES.AGENCY || role === ROLES.COMPANY || role === ROLES.STUDENT || role === ROLES.FACILITY) &&
              <CallToAction />
            }
            <div className="row">
              <div className="col-12 col-lg-4">
                {
                  dataPage &&
                  <LeftSide
                    categories={forum_categories}
                    banners={dataPage.banners} />
                }
              </div>
              <div className="col-12 col-lg-8">
                <div className="forum-list">
                  {
                    isFetchingForum
                      ? <Preloader />
                      : list && list.length > 0
                        ? list.map(item => {
                          return (<ForumCard key={item.id} item={item} categories={forum_categories} />);
                        })
                        : <div className="content-block">
                          <p>Sorry! We didn't find any results for your specific search terms.</p>
                        </div>
                  }
                </div>
                {
                  total > items &&
                  <Pagination
                    total={total}
                    perPage={items}
                    page={pageNumber}
                    isFetching={isFetchingForum}
                    onChange={handlePaginationChange} />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default compose(
  pageLayout(),
  withQueryParams,
  connect(
    (state) => ({
      isAuth: state.auth.isAuth,
      role: state.auth.role,
      total: state.forum.catalog.total,
      items: state.forum.catalog.items,
      list: state.forum.catalog.list,
      isFetchingForum: state.forum.catalog.isFetching,
      isFetchedForum: state.forum.catalog.isFetched,
      forum_categories: state.forum.categories.forum_categories,
      isFetchingCategories: state.forum.categories.isFetching,
      dataPage: state.pages.forums,
    }),
    {
      getCategories: ForumModule.getCategories,
      getCatalog: ForumModule.getCatalog,
      resetCatalog: ForumModule.resetCatalog,
      getForumCommonData: PagesModule.fetch,
    }
  ),
)(Forum);
